module.exports = __webpack_public_path__ + "img/logo.6aef7356.png";